import {BaseViewModel} from "../../../../infrastructure/models/base-view-model";
import {RecordDomainModel} from "./record.domain-model";

export class RecordViewModel extends BaseViewModel {
  domainModel: RecordDomainModel;

  get loses(): Number {
    return this.domainModel.loses;
  }

  get wins(): Number {
    return this.domainModel.wins;
  }

  get ties(): Number {
    return this.domainModel.ties;
  }
}